import { FrequentlyAskedQuestionActions } from './frequently-asked-question.actions';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Apollo } from 'apollo-angular';
import { NotificationService } from 'src/app/services/notification.service';
import { PaginationService } from 'src/app/services/pagination.service';
import { AppState } from '../../reducers';
import { catchError, map, of, switchMap } from 'rxjs';
import { CREATE_FREQUENTLY_ASKED_QUESTION_MUTATION, DELETE_FREQUENTLY_ASKED_QUESTION_MUTATION, GET_FREQUENTLY_ASKED_QUESTION_QUERY, UPDATE_FREQUENTLY_ASKED_QUESTION_MUTATION } from './frequently-asked-question.graphql';
import { Update } from '@ngrx/entity';
import { FrequentlyAskedQuestion } from './frequently-asked-question.model';



@Injectable()
export class FrequentlyAskedQuestionEffects {

  loadFaq$;
  addFaq$;
  updateFaq$;
  deleteFaq$;

  constructor(private actions$: Actions,
    private apollo: Apollo,
    private notificationService: NotificationService,
    private paginationService: PaginationService
  ) {

    this.loadFaq$ = createEffect(() =>
      this.actions$.pipe(
        ofType(FrequentlyAskedQuestionActions.loadFrequentlyAskedQuestions),
        switchMap(() =>
          this.apollo
            .query<any>({
              query: GET_FREQUENTLY_ASKED_QUESTION_QUERY,
            })
            .pipe(
              map((res) => {
                if (res.data?.getAllFaqs.response.status) {
                  return FrequentlyAskedQuestionActions.loadFrequentlyAskedQuestionsSuccess({
                    frequentlyAskedQuestions: res.data?.getAllFaqs.data
                  })
                } else {
                  return FrequentlyAskedQuestionActions.loadFrequentlyAskedQuestionsFailure({
                    error: "Fail to fetch frequently asked question",
                  });
                }
              }),
              catchError((error) => {
                return of(
                  FrequentlyAskedQuestionActions.loadFrequentlyAskedQuestionsFailure({
                    error: "Fail to fetch frequently asked question",
                  })
                );
              })
            )
        )
      )
    );

    this.addFaq$ = createEffect(() =>
      this.actions$.pipe(
        ofType(FrequentlyAskedQuestionActions.addFrequentlyAskedQuestion),
        switchMap(({ frequentlyAskedQuestion}) =>
          this.apollo
            .mutate<any>({
              mutation: CREATE_FREQUENTLY_ASKED_QUESTION_MUTATION,
              variables : {
                input : frequentlyAskedQuestion
              }
            })
            .pipe(
              map((res) => {
                console.log(res)
                if (res.data?.createFaq.response?.status) {
                  this.notificationService.successMessage("Frequently asked question saved successfully")
                  return FrequentlyAskedQuestionActions.addFrequentlyAskedQuestionSuccess({
                    frequentlyAskedQuestion: res.data?.createFaq.data
                  })
                } else {
                  this.notificationService.errorMessage(res.data?.createFaq.response?.message)
                  return FrequentlyAskedQuestionActions.addFrequentlyAskedQuestionFailure({
                    error: res.data?.createFaq.response?.message,
                  });
                }
              }),
              catchError((error) => {
                console.log(error)
                this.notificationService.catchError("Fail to save frequently asked question")
                return of(
                  FrequentlyAskedQuestionActions.addFrequentlyAskedQuestionFailure({
                    error: "Fail to save frequently asked question",
                  })
                );
              })
            )
        )
      )
    );



    this.updateFaq$ = createEffect(() =>
      this.actions$.pipe(
        ofType(FrequentlyAskedQuestionActions.updateFrequentlyAskedQuestion),
        switchMap(({ frequentlyAskedQuestion }) =>
          this.apollo
            .mutate<any>({
              mutation: UPDATE_FREQUENTLY_ASKED_QUESTION_MUTATION,
              variables: {
                input: frequentlyAskedQuestion
              }
            })
            .pipe(
              map((res) => {
                console.log(res)
                if (res.data?.updateFaq.response.status) {
                  const updatedData: Update<FrequentlyAskedQuestion> = {
                    id: frequentlyAskedQuestion.uniqueId,
                    changes: res.data?.updateFaq.data
                  }
                  this.notificationService.successMessage("Frequently asked question updated successfully")
                  return FrequentlyAskedQuestionActions.updateFrequentlyAskedQuestionSuccess({
                    frequentlyAskedQuestion: updatedData
                  })
                } else {
                  this.notificationService.errorMessage(res.data.updateFaq.response.message)
                  return FrequentlyAskedQuestionActions.updateFrequentlyAskedQuestionFailure({
                    error:res.data.updateFaq.response.message,
                  });
                }
              }),
              catchError((error) => {
                console.log(error)
                this.notificationService.errorMessage("Fail to update frequently asked question")
                return of(
                  FrequentlyAskedQuestionActions.updateFrequentlyAskedQuestionFailure({
                    error: "Fail to update frequently asked question",
                  })
                );
              })
            )
        )
      )
    );


    this.deleteFaq$ = createEffect(() =>
      this.actions$.pipe(
        ofType(FrequentlyAskedQuestionActions.deleteFrequentlyAskedQuestion),
        switchMap(({ uniqueId }) =>
          this.apollo
            .mutate<any>({
              mutation: DELETE_FREQUENTLY_ASKED_QUESTION_MUTATION,
              variables: {uniqueId}
            })
            .pipe(
              map((res) => {
                if (res.data?.deleteFaq?.response.status) {
                  this.notificationService.successMessage("Frequently asked question deleted successfully")
                  return FrequentlyAskedQuestionActions.deleteFrequentlyAskedQuestionSuccess({
                    uniqueId
                  })
                } else {
                  this.notificationService.errorMessage(res.data?.deleteFaq?.response.message)
                  return FrequentlyAskedQuestionActions.deleteFrequentlyAskedQuestionFailure({
                    error: res.data?.deleteFaq?.response.message,
                  });
                }
              }),
              catchError((error) => {
                this.notificationService.errorMessage("Fail to delete frequently asked question")
                return of(
                  FrequentlyAskedQuestionActions.deleteFrequentlyAskedQuestionFailure({
                    error: "Fail to delete frequently asked question",
                  })
                );
              })
            )
        )
      )
    );




  }
}
